import { render, staticRenderFns } from "./tabTwo.vue?vue&type=template&id=89e3f184"
import script from "./tabTwo.vue?vue&type=script&lang=js"
export * from "./tabTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports